var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('VideoPreview',{ref:"refVideoPreview",attrs:{"audioUrl":_vm.config.audioUrl,"subtitles":_vm.config.subtitles,"config":_vm.config.config,"isRecording":true},on:{"onEnded":_vm.onEnded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }